export const Overlay = ({ children, className = '' }) => {
  return (
    <div className={`absolute inset-0 bg-gray-100 bg-opacity-50 flex items-center justify-center text-white text-lg z-50 ${className}`}>
      {children}
    </div>
  )
}
